// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"db5d8f326a74b41e","888":"a8edb567d4381025"}[chunkId] + ".css";
};